/* Chef n' Dough theme behaviour — vanilla JS, no dependencies */
(function () {
  'use strict';
  var CND = window.CND = window.CND || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KEYS = { date: CND.p_date || 'Delivery date', slot: CND.p_slot || 'Delivery slot', pin: CND.p_pin || 'Pincode', msg: CND.p_msg || 'Gift message', area: CND.p_area || 'Delivery area' };
  CND.keys = KEYS;

  function money(cents) {
    var fmt = CND.moneyFormat || 'Rs. {{amount}}';
    var n = cents / 100;
    var whole = Math.round(n).toLocaleString('en-IN');
    var dec = n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var out = fmt.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, whole).replace(/\{\{\s*amount_with_comma_separator[^}]*\}\}/, dec).replace(/\{\{\s*amount[^}]*\}\}/, (n % 1 === 0 ? whole : dec));
    var tmp = document.createElement('div'); tmp.innerHTML = out; return tmp.textContent;
  }
  CND.money = money;
  function store(key, val) { try { if (val === undefined) return window.localStorage.getItem(key); window.localStorage.setItem(key, val); } catch (e) { return null; } return null; }
  function post(url, body) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* ---------- reveal ---------- */
  function initReveal(scope) {
    var els = $$('.c-reveal:not(.is-in)', scope);
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- mobile menu ---------- */
  function initMenu() {
    var menu = $('#c-menu');
    if (!menu || menu._bound) return; menu._bound = true;
    var last;
    function open() { last = document.activeElement; menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; var f = $('.c-menu__panel button', menu); if (f) f.focus(); }
    function close() { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; if (last && last.focus) last.focus(); }
    $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-menu-close]', menu).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) close(); });
  }

  /* ---------- pincode + Jaipur areas ---------- */
  var AREAS = String(CND.areas || '').split(/\r?\n/).map(function (l) {
    var p = l.split('|'); var n = (p[0] || '').trim(), pin = (p[1] || '').replace(/\D/g, '');
    return n && pin.length === 6 ? { name: n, pin: pin } : null;
  }).filter(Boolean);
  function pinOk(pin) {
    if (!/^\d{6}$/.test(pin)) return false;
    var deny = String(CND.pinDeny || '').split(/[\s,]+/).filter(Boolean);
    if (deny.indexOf(pin) > -1) return false;
    var allow = String(CND.pinAllow || '').split(/[\s,]+/).filter(Boolean);
    if (allow.indexOf(pin) > -1) return true;
    if (AREAS.some(function (a) { return a.pin === pin; })) return true;
    var pre = String(CND.pinPrefixes || '302').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    return pre.some(function (p) { return pin.indexOf(p) === 0; });
  }
  CND.pinOk = pinOk;
  function areaFor(pin, prefer) {
    var m = AREAS.filter(function (a) { return a.pin === pin; });
    if (prefer && m.some(function (a) { return a.name === prefer; })) return prefer;
    return m.length === 1 ? m[0].name : '';
  }
  function setPinLabels(pin, area) { $$('[data-pin-label]').forEach(function (el) { el.textContent = area || pin || el.getAttribute('data-default') || ''; }); }
  var pickers = [];
  function broadcast(v, a, src) {
    pickers.forEach(function (b) { if (b !== src && b._set && (b._val() !== v || b._area() !== a)) b._set(v, a); });
  }
  function initPins(scope) {
    var sp = store('cnd_pin') || '', sa = store('cnd_area') || '';
    if (sp && !pinOk(sp)) { sp = ''; sa = ''; }
    if (sp) setPinLabels(sp, sa);
    $$('[data-pin]', scope).forEach(function (box) {
      if (box._bound) return; box._bound = true;
      var wrap = box.closest('[data-pin-wrap]') || box.parentNode;
      var input = $('input', box), btn = $('button', box);
      var msg = $('.c-pin__msg', wrap), sel = $('[data-area]', wrap);
      var area = '';
      if (!input) return;
      function setSelect(v, ok) {
        if (!sel) return;
        var pick = '', same = 0;
        $$('option', sel).forEach(function (o, i) {
          if (v && o.value === v) { same++; if (pick === '' && (!area || o.getAttribute('data-name') === area)) pick = i; }
        });
        if (same > 1 && !area) pick = '';
        if (pick !== '') sel.selectedIndex = pick;
        else if (v && same > 1) sel.value = '';
        else sel.value = v ? 'other' : (sel.value === 'other' ? 'other' : '');
        sel.parentNode.classList.toggle('is-picked', !!(ok && v));
      }
      function check(silent, keepArea) {
        var v = (input.value || '').replace(/\D/g, '').slice(0, 6);
        input.value = v;
        var ok = pinOk(v);
        if (!keepArea) area = ok ? areaFor(v, area) : '';
        if (!ok) area = '';
        setSelect(v, ok);
        box.setAttribute('data-ok', ok ? '1' : (v ? '0' : ''));
        if (msg && !(silent && !ok)) {
          msg.className = 'c-pin__msg ' + (v ? (ok ? 'ok' : 'no') : '');
          msg.textContent = !v ? '' : ok ? (CND.t_pin_ok || 'Yes! We deliver to ') + (area ? area + ' (' + v + ')' : v) + '.' : (CND.t_pin_no || 'We deliver within Jaipur only for now.');
        }
        if (ok) { store('cnd_pin', v); store('cnd_area', area); setPinLabels(v, area); broadcast(v, area, box); }
        box.dispatchEvent(new CustomEvent('cnd:pin', { bubbles: true, detail: { ok: ok, pin: v, area: area } }));
        return ok;
      }
      box._check = check;
      box._val = function () { return input.value; };
      box._area = function () { return area; };
      box._set = function (v, a) { input.value = v; area = a || ''; check(true, true); };
      box._input = input; box._sel = sel;
      if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); check(false); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(false); } });
      input.addEventListener('input', function () {
        input.value = input.value.replace(/\D/g, '').slice(0, 6);
        if (input.value.length === 6) check(false);
        else { if (msg) { msg.textContent = ''; msg.className = 'c-pin__msg'; } box.setAttribute('data-ok', ''); if (sel) sel.parentNode.classList.remove('is-picked'); }
      });
      if (sel) sel.addEventListener('change', function () {
        if (sel.value === 'other') {
          area = ''; input.value = ''; box.setAttribute('data-ok', '');
          if (msg) { msg.textContent = ''; msg.className = 'c-pin__msg'; }
          sel.parentNode.classList.remove('is-picked');
          box.dispatchEvent(new CustomEvent('cnd:pin', { bubbles: true, detail: { ok: false, pin: '', area: '' } }));
          setTimeout(function () { input.focus(); }, 50);
        } else if (sel.value) {
          var o = sel.options[sel.selectedIndex];
          area = o.getAttribute('data-name') || ''; input.value = sel.value; check(false, true);
        }
      });
      pickers.push(box);
      if (sp && !input.value) { input.value = sp; area = sa; check(true, true); }
      else if (input.value) check(true);
    });
    var modal = $('#c-area');
    if (modal && !modal._bound) {
      modal._bound = true;
      var last;
      var close = function () { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; if (last && last.focus) last.focus(); };
      modal._open = function () {
        var menu = $('#c-menu'); if (menu && menu.classList.contains('is-open')) { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); }
        last = document.activeElement; modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
        var f = $('select', modal) || $('input', modal); if (f) setTimeout(function () { f.focus(); }, 60);
      };
      $$('[data-area-close]', modal).forEach(function (b) { b.addEventListener('click', close); });
      var done = $('[data-area-done]', modal);
      if (done) done.addEventListener('click', function () {
        var box = $('[data-pin]', modal);
        if (box && box._val()) { if (!box._check(false)) return; }
        close();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
    }
    $$('[data-pin-focus]', scope).forEach(function (b) {
      if (b._bound) return; b._bound = true;
      b.addEventListener('click', function () {
        var m = $('#c-area');
        if (m && m._open) { m._open(); return; }
        var t = $('[data-pin-wrap] select, [data-pin] input');
        if (t) { t.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { t.focus(); }, 450); }
        else { window.location.href = (CND.collectionUrl || root + 'collections/all'); }
      });
    });
  }

  /* ---------- cart / drawer ---------- */
  var drawer;
  function getDrawer() { drawer = drawer || $('#c-drawer'); return drawer; }
  function openDrawer() {
    var d = getDrawer();
    if (!d) { window.location.href = root + 'cart'; return; }
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var c = $('[data-drawer-close].c-iconbtn', d); if (c) c.focus();
  }
  function closeDrawer() {
    var d = getDrawer(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  CND.openDrawer = openDrawer;
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = !count; });
  }
  function updateFoot(cart) {
    var d = getDrawer(); if (!d) return;
    var foot = $('[data-drawer-foot]', d); if (!foot) return;
    var min = parseInt(CND.minOrder || 0, 10) * 100;
    foot.hidden = !cart.item_count;
    $$('[data-cart-subtotal]', foot).forEach(function (e) { e.textContent = money(cart.total_price); });
    var below = min > 0 && cart.total_price < min;
    var ok = $('[data-foot-ok]', foot), low = $('[data-foot-low]', foot);
    if (ok) ok.hidden = below;
    if (low) { low.hidden = !below; var amt = $('[data-left]', low); if (amt) amt.textContent = money(min - cart.total_price); }
  }
  function renderDrawer(html, added) {
    var d = getDrawer(); if (!d || !html) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = $('[data-drawer-inner]', tmp), cur = $('[data-drawer-inner]', d);
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    var note = $('[data-added]', d);
    if (note) note.hidden = !added;
    bindLines(d, false);
    bindQuickAdd(d);
  }
  function refresh(added) {
    return fetch(root + '?sections=cnd-cart-drawer').then(function (r) { return r.json(); })
      .then(function (s) { renderDrawer(s['cnd-cart-drawer'], added); return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) { updateCount(cart.item_count); updateFoot(cart); document.dispatchEvent(new CustomEvent('cnd:cart', { detail: cart })); return cart; });
  }
  CND.refreshCart = refresh;
  function isCartPage() { return document.body.getAttribute('data-template') === 'cart'; }
  function addItems(items, attributes) {
    return post('cart/add.js', { items: items })
      .then(function () { if (attributes) return post('cart/update.js', { attributes: attributes }).catch(function () {}); })
      .then(function () {
        if (isCartPage()) { window.location.reload(); return null; }
        return refresh(true).then(function () { openDrawer(); });
      });
  }
  CND.addItems = addItems;
  function changeLine(key, qty, reload) {
    return post('cart/change.js', { id: key, quantity: qty, sections: reload ? undefined : 'cnd-cart-drawer' })
      .then(function (cart) {
        if (reload) { window.location.reload(); return; }
        if (cart.sections) renderDrawer(cart.sections['cnd-cart-drawer'], false);
        updateCount(cart.item_count); updateFoot(cart);
      }).catch(function (err) { window.alert((err && (err.description || err.message)) || 'Could not update your bag.'); if (reload) window.location.reload(); else refresh(false); });
  }
  function bindLines(scope, reload) {
    $$('[data-line-qty]', scope).forEach(function (wrap) {
      if (wrap._bound) return; wrap._bound = true;
      var key = wrap.getAttribute('data-line-qty'), input = $('input', wrap);
      var bkey = wrap.getAttribute('data-batch');
      function capOk(newQty) {
        if (!bkey) return true;
        var b = batchByKey(bkey); if (!b) return true;
        var total = 0;
        $$('[data-line-qty]').forEach(function (w) {
          if (w.getAttribute('data-batch') !== bkey) return;
          var per = parseInt(w.getAttribute('data-per'), 10) || 1;
          var q = w === wrap ? newQty : (parseInt(($('input', w) || {}).value, 10) || 0);
          if (w.closest('#c-drawer') && !wrap.closest('#c-drawer')) return;
          if (!w.closest('#c-drawer') && wrap.closest('#c-drawer')) return;
          total += q * per;
        });
        var line = wrap.closest('.c-item'), m = line ? $('[data-cap-msg]', line) : null;
        if (total > b.max) { if (m) m.textContent = 'Max ' + b.max + ' ' + (CND.capUnit || 'pieces') + ' per batch — this one is full. Try another slot.'; return false; }
        if (m) m.textContent = '';
        return true;
      }
      function go(q) { q = Math.max(0, q); if (!capOk(q)) { input.value = input.defaultValue; return; } wrap.style.opacity = '.5'; changeLine(key, q, reload); }
      $$('button', wrap).forEach(function (b) {
        b.addEventListener('click', function () { var cur = parseInt(input.value, 10) || 0; var q = cur + (b.hasAttribute('data-plus') ? 1 : -1); if (b.hasAttribute('data-plus') && !capOk(q)) return; go(q); });
      });
      if (!input.readOnly) input.addEventListener('change', function () { go(parseInt(input.value, 10) || 0); });
    });
    $$('[data-line-remove]', scope).forEach(function (b) {
      if (b._bound) return; b._bound = true;
      b.addEventListener('click', function () { b.disabled = true; changeLine(b.getAttribute('data-line-remove'), 0, reload); });
    });
  }
  function initDrawer() {
    var d = getDrawer(); if (!d || d._bound) return; d._bound = true;
    d.addEventListener('click', function (e) { if (e.target.closest('[data-drawer-close]')) closeDrawer(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.classList.contains('is-open')) closeDrawer(); });
    $$('[data-drawer-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { if (isCartPage()) return; e.preventDefault(); openDrawer(); });
    });
    bindLines(d, false);
  }
  function savedDelivery() {
    var d = null;
    try { d = JSON.parse(store('cnd_delivery') || 'null'); } catch (e) { d = null; }
    if (!d || !d.props || !d.iso) return null;
    var now = new Date(); now.setSeconds(0, 0);
    var earliest = new Date(now.getTime() + parseFloat(CND.leadHours || 0.5) * 3600 * 1000);
    var p = d.iso.split('-');
    if (d.start === null || d.start === undefined) {
      if (d.iso < iso(earliest)) return null;
    } else {
      var t = new Date(+p[0], +p[1] - 1, +p[2], Math.floor(d.start), Math.round((d.start % 1) * 60));
      if (t.getTime() < earliest.getTime()) return null;
    }
    return d.props;
  }
  function bindQuickAdd(scope) {
    $$('[data-quick-add]', scope).forEach(function (b) {
      if (b._bound) return; b._bound = true;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var props = savedDelivery();
        var url = b.getAttribute('data-product-url');
        if (!props && url) { window.location.href = url; return; }
        props = props || {};
        b.disabled = true; b.style.opacity = '.6';
        addItems([{ id: parseInt(b.getAttribute('data-quick-add'), 10), quantity: 1, properties: props }])
          .catch(function (err) { window.alert((err && (err.description || err.message)) || 'Could not add to bag.'); })
          .then(function () { b.disabled = false; b.style.opacity = ''; });
      });
    });
  }

  /* ---------- cart page ---------- */
  function initCartPage() {
    var page = $('[data-cart-page]');
    if (!page || page._bound) return; page._bound = true;
    bindLines(page, true);
    var note = $('[data-cart-note]', page);
    if (note) {
      var t;
      var save = function () { return post('cart/update.js', { note: note.value }).catch(function () {}); };
      note.addEventListener('input', function () { clearTimeout(t); t = setTimeout(save, 400); });
      var form = note.form;
      if (form) form.addEventListener('submit', function () { clearTimeout(t); });
    }
  }

  /* ---------- delivery picker ---------- */
  var WEEK = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function fmtDate(d) { return WEEK[d.getDay()] + ', ' + d.getDate() + ' ' + MON[d.getMonth()] + ' ' + d.getFullYear(); }
  function iso(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function sameDay(a, b) { return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); }
  function parseSlots(src) {
    return String(src || '').split(/\n|;/).map(function (l) {
      var p = l.split('|'); var label = (p[0] || '').trim(); if (!label) return null;
      var st = p[1] !== undefined && p[1].trim() !== '' ? parseFloat(p[1]) : null;
      return { label: label, start: isNaN(st) ? null : st };
    }).filter(Boolean);
  }
  CND.parseSlots = parseSlots;
  CND._initDelivery = function (f, cb) { return initDelivery(f, cb); };

  /* ---------- batch limits (e.g. bombolones) ---------- */
  var CAP = String(CND.capBatches || '').split(/\r?\n/).map(function (l) {
    var p = l.split('|'); if (p.length < 4) return null;
    var b = { name: p[0].trim(), from: parseFloat(p[1]), to: parseFloat(p[2]), max: parseInt(p[3], 10) };
    return b.name && !isNaN(b.from) && !isNaN(b.to) && b.max >= 0 ? b : null;
  }).filter(Boolean);
  function batchFor(start) { if (start === null || start === undefined) return null; for (var i = 0; i < CAP.length; i++) { if (start >= CAP[i].from && start < CAP[i].to) return CAP[i]; } return null; }
  function batchByKey(key) { var f = parseFloat(String(key).split('|')[1]); for (var i = 0; i < CAP.length; i++) { if (CAP[i].from === f) return CAP[i]; } return null; }
  function normName(t) { return String(t || '').toLowerCase().replace(/batch/g, '').replace(/[^a-z0-9]/g, ''); }
  function batchNames(b) { var h = Math.floor(b.from), h12 = h % 12 || 12; return [normName(b.name), String(h), h12 + (h < 12 ? 'am' : 'pm')]; }
  function normDate(t) {
    var m = String(t || '').match(/(\d{1,4})[-\/.](\d{1,2})[-\/.](\d{1,4})/); if (!m) return '';
    var y, mo, d; if (m[1].length === 4) { y = m[1]; mo = m[2]; d = m[3]; } else { d = m[1]; mo = m[2]; y = m[3]; }
    if (y.length === 2) y = '20' + y;
    return y + '-' + ('0' + mo).slice(-2) + '-' + ('0' + d).slice(-2);
  }
  var FULL = String(CND.capFull || '').split(/\r?\n/).map(function (l) {
    var p = l.split('|'); var dt = normDate(p[0]); if (!dt) return null;
    return { iso: dt, name: normName(p[1] || 'all') || 'all' };
  }).filter(Boolean);
  function batchFull(isoStr, b) {
    var names = batchNames(b);
    return FULL.some(function (f) { return f.iso === isoStr && (f.name === 'all' || names.indexOf(f.name) > -1); });
  }
  function perUnit(t) { var m = String(t || '').match(/\d+/); var n = m ? parseInt(m[0], 10) : 1; return n > 0 && n <= 60 ? n : 1; }
  var cartCache = null;
  document.addEventListener('cnd:cart', function (e) { cartCache = e.detail; });
  function cartPieces(key) {
    if (!cartCache || !cartCache.items) return 0;
    return cartCache.items.reduce(function (sum, it) {
      var pr = it.properties || {};
      if (pr._Batch !== key) return sum;
      return sum + it.quantity * (parseInt(pr._Pieces, 10) || perUnit(it.variant_title));
    }, 0);
  }
  CND._cap = { batchFor: batchFor, batchFull: batchFull, normDate: normDate, perUnit: perUnit };
  function initDelivery(form, onChange) {
    var wrap = $('[data-delivery]', form);
    if (!wrap) return null;
    var datesEl = $('[data-dates]', wrap), slotsEl = $('[data-slots]', wrap), more = $('[data-date-more]', wrap), noSlot = $('[data-noslot]', wrap);
    var uid = form.id || 'f';
    var now = new Date(); now.setSeconds(0, 0);
    var leadAttr = wrap.getAttribute('data-lead');
    var lead = parseFloat(leadAttr !== null && leadAttr !== '' ? leadAttr : (CND.leadHours !== undefined ? CND.leadHours : 0.5));
    if (isNaN(lead)) lead = 0.5;
    var earliest = new Date(now.getTime() + lead * 3600 * 1000);
    var slots = parseSlots(CND.slots);
    var hrs = String(wrap.getAttribute('data-hours') || '').split('|');
    var hFrom = parseFloat(hrs[0]), hTo = parseFloat(hrs[1]);
    if (!isNaN(hFrom) && !isNaN(hTo)) slots = slots.filter(function (s) { return s.start === null || (s.start >= hFrom && s.start < hTo); });
    var maxDays = parseInt(CND.maxDays || 30, 10);
    var closed = String(CND.closedDays || '').split(',').map(function (s) { return s.trim().slice(0, 3).toLowerCase(); }).filter(Boolean);
    var state = { date: null, slot: null };
    function isClosed(d) { return closed.indexOf(WEEK[d.getDay()].toLowerCase()) > -1; }
    var capped = wrap.hasAttribute('data-cap') && CAP.length > 0;
    function slotOpen(d, s) {
      if (isClosed(d)) return false;
      if (capped && s.start !== null) { var cb = batchFor(s.start); if (cb && batchFull(iso(d), cb)) return false; }
      if (s.start === null) { return iso(d) >= iso(earliest); }
      var t = new Date(d.getFullYear(), d.getMonth(), d.getDate(), Math.floor(s.start), Math.round((s.start % 1) * 60));
      return t.getTime() >= earliest.getTime();
    }
    function dayOpen(d) { if (!slots.length) return !isClosed(d) && iso(d) >= iso(earliest); return slots.some(function (s) { return slotOpen(d, s); }); }
    // first open day
    var start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var guard = 0;
    while (!dayOpen(start) && guard < 60) { start.setDate(start.getDate() + 1); guard++; }
    function renderSlots() {
      slotsEl.innerHTML = '';
      var d = state.date, firstFree = null;
      slots.forEach(function (s, i) {
        var dis = !d || !slotOpen(d, s);
        var lab = document.createElement('label'); lab.className = 'c-slot';
        var inp = document.createElement('input'); inp.type = 'radio'; inp.name = uid + '-slot'; inp.value = s.label; inp.disabled = dis;
        var sp = document.createElement('span'); sp.textContent = s.label;
        lab.appendChild(inp); lab.appendChild(sp); slotsEl.appendChild(lab);
        inp.addEventListener('change', function () { state.slot = s.label; sync(); });
        if (!dis && firstFree === null) firstFree = inp;
      });
      var keep = null;
      $$('input', slotsEl).forEach(function (i) { if (i.value === state.slot && !i.disabled) keep = i; });
      var pick = keep || firstFree;
      if (pick) { pick.checked = true; state.slot = pick.value; } else { state.slot = null; }
      var sw = slotsEl.closest('[data-slot-wrap]'); if (sw) sw.hidden = !slots.length;
      if (noSlot) noSlot.hidden = !(slots.length && d && !pick);
      sync();
    }
    function choose(d) { state.date = d; renderSlots(); }
    var chips = [];
    var t0 = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var t1 = new Date(t0); t1.setDate(t0.getDate() + 1);
    var d = new Date(start), added = 0, g = 0;
    while (added < 4 && g < 30) {
      if (dayOpen(d)) {
        var top = sameDay(d, t0) ? 'Today' : sameDay(d, t1) ? 'Tomorrow' : WEEK[d.getDay()];
        var lab = document.createElement('label'); lab.className = 'c-date';
        var inp = document.createElement('input'); inp.type = 'radio'; inp.name = uid + '-date'; inp.value = iso(d);
        inp.setAttribute('aria-label', fmtDate(d));
        var sp = document.createElement('span'); sp.innerHTML = '<small></small><b></b>';
        sp.firstChild.textContent = top; sp.lastChild.textContent = d.getDate() + ' ' + MON[d.getMonth()];
        lab.appendChild(inp); lab.appendChild(sp);
        datesEl.insertBefore(lab, more ? more.parentNode : null);
        (function (dd, ii) { ii.addEventListener('change', function () { if (more) { more.value = ''; more.parentNode.classList.remove('is-picked'); } choose(dd); }); chips.push(ii); })(new Date(d), inp);
        added++;
      }
      d.setDate(d.getDate() + 1); g++;
    }
    if (more) {
      more.min = iso(start);
      var mx = new Date(start); mx.setDate(mx.getDate() + maxDays); more.max = iso(mx);
      more.addEventListener('change', function () {
        if (!more.value) return;
        var p = more.value.split('-'); var dd = new Date(+p[0], +p[1] - 1, +p[2]);
        if (!dayOpen(dd)) { more.value = ''; if (CND.t_closed) window.alert(CND.t_closed); return; }
        var match = false;
        chips.forEach(function (c) { c.checked = c.value === iso(dd); if (c.checked) match = true; });
        more.parentNode.classList.toggle('is-picked', !match);
        choose(dd);
      });
      more.parentNode.addEventListener('click', function () { if (more.showPicker) { try { more.showPicker(); } catch (e) {} } });
    }
    function sync() {
      var txt = state.date ? fmtDate(state.date).replace(/ \d{4}$/, '') + (state.slot ? ' · ' + state.slot : '') : '—';
      $$('[data-eta]', form.closest('[data-product-root]') || document).forEach(function (o) { o.textContent = txt; });
      if (onChange) onChange();
    }
    if (chips[0]) { chips[0].checked = true; choose(new Date(start)); }
    return {
      get: function () {
        if (!state.date) return null;
        if (slots.length && !state.slot) return null;
        var o = {}; o[KEYS.date] = fmtDate(state.date);
        if (state.slot) o[KEYS.slot] = state.slot;
        return o;
      },
      meta: function () {
        if (!state.date) return null;
        var st = null;
        slots.forEach(function (s) { if (s.label === state.slot) st = s.start; });
        return { iso: iso(state.date), start: st, batch: capped ? batchFor(st) : null };
      }
    };
  }


  /* ---------- product ---------- */
  function initProduct(rootEl) {
    if (rootEl._bound) return; rootEl._bound = true;
    var form = $('form[data-product-form]', rootEl);
    if (!form) return;
    var data = {};
    try { data = JSON.parse(($('[data-product-json]', rootEl) || {}).textContent || '{}'); } catch (e) { data = {}; }
    var variants = data.variants || [];
    var idInput = $('input[name="id"]', form);
    var priceEl = $('[data-price]', rootEl), compareEl = $('[data-compare]', rootEl), atcs = $$('[data-atc]', rootEl);
    var qtyInput = $('[data-qty] input', form);
    var pair = $('[data-pair]', form);
    var msg = $('[data-msg]', form), msgCount = $('[data-msg-count]', form);
    var pinBox = $('[data-pin]', form);
    var errEl = $('[data-err]', rootEl);
    var hidden = { date: $('[data-hidden="date"]', form), slot: $('[data-hidden="slot"]', form), pin: $('[data-hidden="pin"]', form), area: $('[data-hidden="area"]', form), msg: $('[data-hidden="msg"]', form), batch: $('[data-hidden="batch"]', form), pieces: $('[data-hidden="pieces"]', form) };
    var current = null;
    variants.forEach(function (v) { if (idInput && v.id === parseInt(idInput.value, 10)) current = v; });
    if (!current) current = variants[0] || null;
    var capped = !!$('[data-delivery][data-cap]', form) && CAP.length > 0;
    var capHint = $('[data-cap-hint]', form);
    var delivery = null;
    delivery = initDelivery(form, function () { syncHidden(); if (capped && variants.length) render(); });
    if (capped) fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { cartCache = c; render(); }).catch(function () {});
    document.addEventListener('cnd:cart', function () { if (capped) render(); });
    function capState() {
      if (!capped || !delivery || !current) return null;
      var m = delivery.meta(); if (!m || !m.batch) return null;
      var key = m.iso + '|' + m.batch.from;
      var used = cartPieces(key), per = perUnit(current.public_title || current.title);
      var left = Math.max(0, m.batch.max - used);
      return { b: m.batch, key: key, per: per, used: used, left: left, maxQty: Math.floor(left / per) };
    }

    function syncHidden() {
      var dp = delivery ? delivery.get() : null;
      if (hidden.date) hidden.date.value = dp ? (dp[KEYS.date] || '') : '';
      if (hidden.slot) hidden.slot.value = dp ? (dp[KEYS.slot] || '') : '';
      var pinGood = false;
      if (hidden.pin) { var pi = pinBox ? $('input', pinBox) : null; pinGood = !!(pi && pinOk(pi.value)); hidden.pin.value = pinGood ? pi.value : ''; }
      if (hidden.area) hidden.area.value = pinGood && pinBox && pinBox._area ? pinBox._area() : '';
      if (hidden.msg) hidden.msg.value = msg ? msg.value.trim() : '';
      if (hidden.batch) { var cs0 = capState(); hidden.batch.value = cs0 ? cs0.key : ''; hidden.pieces.value = cs0 ? String(cs0.per) : ''; }
      [hidden.date, hidden.slot, hidden.pin, hidden.area, hidden.msg, hidden.batch, hidden.pieces].forEach(function (h) { if (h) h.disabled = !h.value; });
    }
    if (pinBox) pinBox.addEventListener('cnd:pin', syncHidden);

    function selected() { return $$('[data-option]', form).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function findVariant(opts) {
      var m = null;
      variants.forEach(function (v) { if (!m && v.options.every(function (o, j) { return o === opts[j]; })) m = v; });
      return m;
    }
    function updateAvailability() {
      var sel = selected();
      $$('[data-option]', form).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var opts = sel.slice(); opts[idx] = inp.value;
          var mv = findVariant(opts);
          inp.parentNode.classList.toggle('is-unavailable', !mv || !mv.available);
          var pe = $('[data-opt-price]', inp.parentNode);
          if (pe && mv) pe.textContent = money(mv.price);
        });
        var lbl = $('[data-opt-selected]', fs); if (lbl) lbl.textContent = sel[idx] || '';
      });
    }
    function total() {
      if (!current) return 0;
      var q = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var t = current.price * q;
      if (pair && pair.checked) t += parseInt(pair.getAttribute('data-price'), 10) || 0;
      return t;
    }
    function render() {
      if (!current) {
        atcs.forEach(function (b) { b.disabled = true; var l = $('[data-atc-label]', b); if (l) l.textContent = CND.t_unavailable || 'Unavailable'; var p = $('[data-atc-price]', b); if (p) p.textContent = ''; });
        return;
      }
      if (idInput) idInput.value = current.id;
      if (priceEl) priceEl.textContent = money(current.price);
      if (compareEl) compareEl.textContent = current.compare_at_price && current.compare_at_price > current.price ? money(current.compare_at_price) : '';
      $$('[data-variant-title]', rootEl).forEach(function (e) { e.textContent = current.public_title || ''; });
      var cs = capState(), capBlocked = false, unit = CND.capUnit || 'pieces';
      if (cs) {
        capBlocked = cs.maxQty < 1;
        if (qtyInput) {
          qtyInput.max = Math.max(1, Math.min(50, cs.maxQty));
          if (!capBlocked && (parseInt(qtyInput.value, 10) || 1) > cs.maxQty) qtyInput.value = cs.maxQty;
        }
        if (capHint) {
          var dTxt = cs.key.split('|')[0].split('-'); dTxt = parseInt(dTxt[2], 10) + ' ' + MON[parseInt(dTxt[1], 10) - 1];
          capHint.classList.toggle('is-warn', capBlocked);
          capHint.textContent = capBlocked
            ? 'The ' + cs.b.name + ' on ' + dTxt + ' is full' + (cs.used ? ' (your bag already has ' + cs.used + ')' : '') + ' — please pick another slot or day.'
            : dTxt + ', ' + cs.b.name + ': max ' + cs.b.max + ' ' + unit + ' per batch — you can add ' + cs.left + ' more' + (cs.per > 1 ? ' (' + cs.maxQty + ' × ' + cs.per + ')' : '') + '.' + (cs.used ? ' (' + cs.used + ' already in your bag)' : '');
        }
      } else if (capHint) { capHint.textContent = ''; }
      if (qtyInput && !cs) qtyInput.max = 50;
      var canBuy = current.available && !capBlocked;
      atcs.forEach(function (b) {
        b.disabled = !canBuy;
        var l = $('[data-atc-label]', b); if (l) l.textContent = !current.available ? (CND.t_sold || 'Sold out for today') : capBlocked ? 'Batch full — pick another slot' : (CND.t_add || 'Add to bag');
        var p = $('[data-atc-price]', b); if (p) p.textContent = canBuy ? money(total()) : '';
      });
      var srs = $$('.sr-headless-checkout, .shiprocket-headless', form);
      srs.forEach(function (el) { el.style.opacity = canBuy ? '' : '0.5'; el.style.pointerEvents = canBuy ? '' : 'none'; });
      syncHidden();
      updateAvailability();
    }
    $$('[data-option] input', form).forEach(function (inp) {
      inp.addEventListener('change', function () {
        current = findVariant(selected());
        render();
        if (current) {
          try { var u = new URL(window.location.href); u.searchParams.set('variant', current.id); window.history.replaceState(null, '', u.toString()); } catch (e) {}
          if (current.featured_media) goToMedia(current.featured_media.id);
          if (idInput) idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
    var qWrap = $('[data-qty]', form);
    if (qWrap && qtyInput) {
      $$('button', qWrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var q = (parseInt(qtyInput.value, 10) || 1) + (b.hasAttribute('data-plus') ? 1 : -1);
          var mx = parseInt(qtyInput.max, 10) || 50;
          qtyInput.value = Math.max(1, Math.min(mx, q)); qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      qtyInput.addEventListener('change', function () { qtyInput.value = Math.max(1, Math.min(parseInt(qtyInput.max, 10) || 50, parseInt(qtyInput.value, 10) || 1)); render(); });
    }
    if (pair) pair.addEventListener('change', render);
    if (msg) {
      var max = parseInt(msg.getAttribute('maxlength'), 10) || 30;
      var upd = function () {
        if (msgCount) msgCount.textContent = msg.value.length + '/' + max;
        $$('[data-msg-preview]', rootEl).forEach(function (e) { e.textContent = msg.value ? '“' + msg.value + '”' : ''; });
        syncHidden();
      };
      msg.addEventListener('input', upd); upd();
    }
    var more = $('[data-desc-more]', rootEl);
    if (more) {
      var desc = $('[data-desc]', rootEl);
      if (desc && desc.scrollHeight <= desc.clientHeight + 4) more.hidden = true;
      more.addEventListener('click', function () { desc.classList.remove('c-buy__desc--clamp'); more.hidden = true; });
    }

    /* gallery */
    var slides = $('[data-slides]', rootEl), thumbs = $$('[data-thumb]', rootEl), countEl = $('[data-count]', rootEl), dots = $$('[data-dot]', rootEl);
    var slideEls = slides ? $$('[data-slide]', slides) : [];
    function idx() { return slides && slides.clientWidth ? Math.round(slides.scrollLeft / slides.clientWidth) : 0; }
    function go(i) { if (!slides || !slideEls.length) return; i = (i + slideEls.length) % slideEls.length; slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' }); }
    function goToMedia(id) { slideEls.forEach(function (s, i) { if (parseInt(s.getAttribute('data-slide'), 10) === id) go(i); }); }
    if (slides && slideEls.length) {
      var onScroll = function () {
        var i = idx();
        thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        dots.forEach(function (t, j) { t.classList.toggle('on', j === i); });
        if (countEl) countEl.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + slideEls.length).slice(-2);
        slideEls.forEach(function (s, j) { var v = $('video', s); if (v && j !== i) v.pause(); });
      };
      slides.addEventListener('scroll', function () { clearTimeout(slides._t); slides._t = setTimeout(onScroll, 60); }, { passive: true });
      thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
      var prev = $('[data-prev]', rootEl), next = $('[data-next]', rootEl);
      if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
      if (next) next.addEventListener('click', function () { go(idx() + 1); });
      onScroll();
      if (current && current.featured_media && data.selectedFromUrl) goToMedia(current.featured_media.id);
    }

    /* sticky bar (mobile) */
    var sticky = $('[data-sticky]', rootEl), mainAtc = $('[data-atc-main]', rootEl);
    if (sticky && mainAtc) {
      var ticking = false;
      var checkSticky = function () { ticking = false; var r = mainAtc.getBoundingClientRect(); sticky.classList.toggle('is-shown', r.bottom < 0); };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(checkSticky); } }, { passive: true });
      checkSticky();
      var sBtn = $('[data-atc]', sticky);
      if (sBtn) sBtn.addEventListener('click', function (e) { e.preventDefault(); submit(); });
    }

    function fail(t, focusEl) {
      if (errEl) { errEl.textContent = t; errEl.classList.add('is-shown'); errEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      if (focusEl) setTimeout(function () { focusEl.focus(); }, 350);
    }
    function submit() {
      if (errEl) errEl.classList.remove('is-shown');
      if (!current || !current.available) return;
      syncHidden();
      var props = {};
      var attrs = {};
      if (pinBox) {
        var pinInput = $('input', pinBox);
        var hasPin = pinInput && pinInput.value;
        var ok = hasPin ? pinBox._check(false) : false;
        if (hasPin && !ok) { fail(CND.t_pin_no || 'We deliver within Jaipur only for now.', pinInput); return; }
        if (!hasPin && CND.requirePin) { fail((AREAS.length ? CND.t_pick_area : CND.t_need_pin) || 'Please enter your delivery pincode.', pinBox._sel || pinInput); return; }
        if (ok) {
          props[KEYS.pin] = pinInput.value; attrs[KEYS.pin] = pinInput.value;
          var ar = pinBox._area ? pinBox._area() : '';
          if (ar) { props[KEYS.area] = ar; attrs[KEYS.area] = ar; }
        }
      }
      if (delivery) {
        var dp = delivery.get();
        if (!dp) { fail(CND.t_need_date || 'Please choose a delivery date and slot.'); return; }
        Object.keys(dp).forEach(function (k) { props[k] = dp[k]; attrs[k] = dp[k]; });
        var meta = delivery.meta();
        store('cnd_delivery', JSON.stringify({ props: attrs, iso: meta && meta.iso, start: meta ? meta.start : null }));
      }
      if (msg && msg.value.trim()) props[KEYS.msg] = msg.value.trim();
      var qn = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var cs = capState();
      if (cs) {
        if (qn * cs.per > cs.left) { fail(cs.left ? 'Only ' + cs.left + ' more ' + (CND.capUnit || 'pieces') + ' can go in the ' + cs.b.name + ' for this day. Lower the quantity or pick another slot.' : 'The ' + cs.b.name + ' is full for this day — please pick another slot.'); return; }
        props._Batch = cs.key; props._Pieces = String(cs.per);
      }
      var items = [{ id: current.id, quantity: qn, properties: props }];
      if (pair && pair.checked) {
        var pp = {}; Object.keys(attrs).forEach(function (k) { pp[k] = attrs[k]; });
        items.push({ id: parseInt(pair.value, 10), quantity: 1, properties: pp });
      }
      atcs.forEach(function (b) { b.classList.add('is-loading'); });
      addItems(items, Object.keys(attrs).length ? attrs : null)
        .catch(function (err) { fail((err && (err.description || err.message)) || 'Could not add to bag. Please try again.'); })
        .then(function () { atcs.forEach(function (b) { b.classList.remove('is-loading'); }); });
    }
    form.addEventListener('submit', function (e) {
      var sub = e.submitter;
      if (sub && sub.getAttribute('name') !== 'add' && !sub.hasAttribute('data-atc')) return; // let other buttons (e.g. checkout apps) behave natively
      e.preventDefault();
      submit();
    });
    render();
    syncHidden();
  }

  /* ---------- misc ---------- */
  function initSort() {
    $$('[data-sort]').forEach(function (s) {
      if (s._bound) return; s._bound = true;
      s.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u.toString(); });
    });
  }
  function initShare() {
    $$('[data-share]').forEach(function (b) {
      if (b._bound) return; b._bound = true;
      b.addEventListener('click', function (e) {
        var url = b.getAttribute('data-share') || window.location.href;
        if (navigator.share) { e.preventDefault(); navigator.share({ title: document.title, url: url }).catch(function () {}); }
      });
    });
    $$('[data-copy]').forEach(function (b) {
      if (b._bound) return; b._bound = true;
      b.addEventListener('click', function (e) {
        if (navigator.share && b.hasAttribute('data-share')) return;
        e.preventDefault();
        var v = b.getAttribute('data-copy');
        if (navigator.clipboard) navigator.clipboard.writeText(v).then(function () { var o = b.getAttribute('aria-label'); b.setAttribute('aria-label', 'Copied'); b.style.borderColor = 'var(--c-ok)'; setTimeout(function () { b.setAttribute('aria-label', o); b.style.borderColor = ''; }, 1600); });
      });
    });
  }
  function initRecs() {
    $$('[data-recs]').forEach(function (el) {
      if (el._bound) return; el._bound = true;
      fetch(el.getAttribute('data-recs')).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = $('[data-recs]', tmp);
        if (inner && inner.innerHTML.trim()) {
          el.innerHTML = inner.innerHTML;
          var sec = el.closest('[data-recs-section]'); if (sec) sec.hidden = false;
          bindQuickAdd(el);
        }
      }).catch(function () {});
    });
  }

  function init(scope) {
    initReveal(scope); initMenu(); initPins(scope); initDrawer(); bindQuickAdd(scope); initCartPage(); initSort(); initShare(); initRecs();
    $$('[data-product-root]', scope).forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
